import { lighten, normalize, transparentize } from 'polished'
import { createGlobalStyle } from 'styled-components'

// Global Styles

export default createGlobalStyle`
  ${normalize()}

  html {
    height: 100%;
  }

  body {
    font-family: "Roboto", "Segoe UI", "Monospaced Number", "Chinese Quote", -apple-system, BlinkMacSystemFont, Roboto, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif;
    height: 100%;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: "Saira", "Segoe UI", "Monospaced Number", "Chinese Quote", -apple-system, BlinkMacSystemFont, Roboto, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif;
    color: inherit;
  }

  a:hover, a:visited, a:link, a:active {
    text-decoration: none;
  }

  *, * * {
    box-sizing: border-box
  }

  img {
    margin-bottom: 0
  }

  ul {
    list-style: none;
  }

  a, a:visited {
    text-decoration: none;
  }

  div.tippy-popper[aria-hidden="true"] {
    display: none;
  }

  code {
    padding: 0px 5px;
    background: #121212;
    border-radius: 3px;
    display: inline-block;
  }

  /* -----
  SVG Icons - svgicons.sparkk.fr
  ----- */

  .svg-icon {
    height: 3em;
  }

  .svg-icon path,
  .svg-icon polygon,
  .svg-icon rect {
    fill: ${p => lighten(0.4, p.theme.darkBlue)};
  }

  .svg-icon.error-icon path,
  .svg-icon.error-icon polygon,
  .svg-icon.error-icon rect {
    fill: ${p => p.theme.error};
  }

  .svg-icon circle {
    stroke: #4691f6;
    stroke-width: 1;
  }

  .rsr-container input {
    display: none;
  }

  .ant-calendar-month-panel-month.ant-calendar-month-panel-month,
  .ant-calendar-month-panel-header.ant-calendar-month-panel-header,
  .ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn.ant-calendar-month-panel-prev-year-btn,
  .ant-calendar-month-panel-year-select-content,
  .ant-select-selection--multiple .ant-select-selection__choice__remove,
  .ant-select-dropdown-menu-item.ant-select-dropdown-menu-item-selected,
  .ant-select-dropdown-menu-item.ant-select-dropdown-menu-item-selected:hover {
    color: ${p => p.theme.textTransBlack};
  }
  .ant-select-dropdown-menu-item, .ant-input-number-handler-down-inner, .ant-input-number-handler-up-inner {
    color: ${p => p.theme.textTransBlack} !important;
  }

  .ant-rate {
    font-size: inherit;

    &.ant-rate-disabled .ant-rate-star {
      cursor: pointer;
    }

    .ant-rate-star-half .ant-rate-star-first,
    .ant-rate-star-full .ant-rate-star-second {
      color: inherit;
    }

    .ant-rate-star-first,
    .ant-rate-star-second {
      color: #535b69;
    }

    .ant-rate-star {
      margin-right: 2px;
      transition: none;
    }
  }

  .ant-popover {
    .ant-popover-title {
      border-bottom-color: ${transparentize(0.73, '#fff')};
    }

    .ant-popover-inner, .ant-popover-arrow {
      background: ${p => p.theme.antLink};
    }

    &.hide-inner-content {
      .ant-popover-title {
        border: none;
      }
      .ant-popover-inner-content {
        display: none;
      }
    }
  }

  .ant-menu-submenu > .ant-menu {
    box-shadow: 0 2px 13px -1px #000;
    background: #2d2d2d;
  }

  strong {
    font-weight: bolder;
  }

  .ril-toolbar.ril__toolbar {
    justify-content: space-around;
    justify-content: space-evenly;
  }
`



// WEBPACK FOOTER //
// /opt/build/repo/src/styles/styled-global.js